<template>
<div class="loading-wrapper">
  <div class="loading-text">
    <div class="md-layout">
      <div class="md-layout-item"></div>
      <div class="md-layout-item md-size-33">
        <md-content class="md-elevation-10 pos-r">
          <md-progress-bar class="loading md-primary pos-a" md-mode="indeterminate" />
          <div class="loading-text-inner md-body-2 ta-c">
            <md-icon class="mr-1">update</md-icon>
            {{ $t('notification.loading') }}
          </div>
        </md-content>
      </div>
      <div class="md-layout-item"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'LoadingView'
}
</script>

<style lang="scss" scoped>
.loading-wrapper {
  position: fixed;
  top: 72px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.8);
  z-index: 999;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.loading-text {
  position: absolute;
  top: 84px;
  left: 0;
  right: 0;
}
.loading-text-inner {
  padding: 28px 0 24px;
}
</style>
